import { Link, useNavigate } from "react-router-dom";
import { siteRoute } from "@/lib/domains";
import { SmartLink } from "@/components/shared/SmartLink";
import "@/styles/footer.css";

export const Footer = () => {
  const navigate = useNavigate();

  const handleAboutClick = () => {
    if (typeof window !== 'undefined' && typeof window.openAboutOverlay === 'function') {
      window.openAboutOverlay();
      return;
    }
    // We're not on a page that exposes the overlay — go home and auto-open it
    navigate('/?about=1');
  };

  return (
    <footer className="nymphe-strip" data-testid="site-footer">
      <div className="nymphe-strip__inner">
        <div className="nymphe-strip__brand" data-testid="footer-brand">NYMPHÉ</div>

        <div className="nymphe-strip__mid">
          <nav className="nymphe-strip__links" aria-label="Footer links">
            <button
              type="button"
              className="nymphe-strip__about"
              onClick={handleAboutClick}
              data-testid="footer-about-link"
            >
              About
            </button>
            <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/safety" data-testid="footer-safety-link">Safety</Link>
            <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
            <Link to="/faq" data-testid="footer-faq-link">FAQ</Link>
            <Link to="/brand-kit" data-testid="footer-brand-kit-link">Brand Kit</Link>
            <Link to="/terms" data-testid="footer-terms-link">Terms</Link>
            <SmartLink
              to={siteRoute('/access')}
              className="nymphe-strip__access"
              data-testid="footer-access-link"
            >
              Early Access
            </SmartLink>
          </nav>

          <div className="nymphe-strip__socials" aria-label="Social links">
            <a
              href="https://www.instagram.com/nymphe.app/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <circle cx="12" cy="12" r="5" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a
              href="https://x.com/nympheapp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X"
              data-testid="footer-x"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="nymphe-strip__sign" data-testid="footer-sign">
          © 2026 NYMPHÉ. Curated privately.
        </div>
      </div>
    </footer>
  );
};
